import moment from 'moment';

function fishermanTimeToMoment(fishrmnTime) {
  return moment(fishrmnTime.toString().padStart(4, '0'), 'HHmm')
}

export function getOpeningHours(hours) {
  const HOURS_LABELS = {
    1: 'Mo',
    2: 'Tu',
    3: 'We',
    4: 'Th',
    5: 'Fr',
    6: 'Sa',
    7: 'Su'
  };
  if (hours) {
    return hours.map(({day, open, close}) => {
      const openStr = fishermanTimeToMoment(open).format('HH:mm');
      const closeStr = fishermanTimeToMoment(close).format('HH:mm');
      return `${HOURS_LABELS[day]} ${openStr} - ${closeStr}`;
    });
  }
  return undefined;
}

export function getOpeningHoursSpecification(hours) {
  const DAY_OF_WEEK = {
    1: 'https://schema.org/Monday',
    2: 'https://schema.org/Tuesday',
    3: 'https://schema.org/Wednesday',
    4: 'https://schema.org/Thursady',
    5: 'https://schema.org/Friday',
    6: 'https://schema.org/Saturday',
    7: 'https://schema.org/Sunday'
  };
  if (hours) {
    return hours.map(({day, open, close}) => {
      const openStr = fishermanTimeToMoment(open).format('HH:mm:ss');
      const closeStr = fishermanTimeToMoment(close).format('HH:mm:ss');
      return {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": DAY_OF_WEEK[day],
        "opens":  openStr,
        "closes":  closeStr,
      }
    })
  }
}
